import styled from "styled-components";
import { shade850 } from "../../styles/tokens";

// TEXT

// STYLES
export const Divider = styled.div<Props>`
  min-height: ${({ $direction = "horizontal", $length }) =>
    $direction === "horizontal" ? "0.0625rem" : $length || "auto"};
  min-width: ${({ $direction, $length }) =>
    $direction === "vertical" ? "0.0625rem" : $length || "auto"};
  background: ${({ $color }) => $color || shade850};
  padding: ${({ $padding }) => $padding || "0"};
  margin: ${({ $margin }) => $margin || "0"};
  background-clip: content-box;
`;

// DATA

// TYPES
type Props = {
  $direction?: "horizontal" | "vertical";
  $length?: string;
  $color?: string;
  $padding?: string;
  $margin?: string;
};

// CONSTANTS

// FUNCTIONS

// ASSETS
